var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false},on:{"before-enter":_vm.before_enter,"enter":_vm.enter,"after-enter":_vm.after_enter,"before-leave":_vm.before_leave,"leave":_vm.leave,"after-leave":_vm.after_leave}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }